const registerServiceWorker = async (): Promise<
  ServiceWorkerRegistration | undefined
> => {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  const serviceWorkerUrl = `${process.env.PUBLIC_URL}/firebase-messaging-sw.js`;

  try {
    return await navigator.serviceWorker.register(serviceWorkerUrl);
  } catch (error) {
    console.warn("Service worker registration failed", error);
  }
};

export default registerServiceWorker;
